import {useContext} from 'react';

import {Box} from '@mui/material';

import {CompanyBanner} from './CompanyBanner';
import {CompanyDescription} from './CompanyDescription';
import {CompanyOverview} from './CompanyOverview';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {useFallBackLogo} from '../../../../../hooks/useFallBackLogo';
import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {capitalizeFirstLetter} from '../../../../../utils/capitalizeFirstLetter';
import {formatMissingText} from '../../../../../utils/formatMissingText';
import {safelyUseLanguageProfile} from '../../../../../utils/safelyUseLanguageProfile';
import {CompanyProfile} from '../../../../company/profile/types';

interface Props {
  companyProfile: CompanyProfile;
}
export const CompanySummary = ({companyProfile: profile}: Props) => {
  const backgroundColor = orangeColors[5];
  const lang = useContext(LanguageContext);
  const avatarUrl = useFallBackLogo(profile.logoUrl);
  const {
    name,
    description,
    slogan,
    companyType,
    primaryCompanyLanguage,
    averageEmployeeAge,
    employeeCountRange,
    percOfWomenInLeadership,
    industry,
    workMode,
    percOfEmployeesAreParents,
    locations,
    websiteUrl,
  } = profile;

  return (
    <EmpionPaper sx={{backgroundColor, overflow: 'hidden', borderRadius: '16px'}}>
      <CompanyBanner bannerUrl={profile.headerImageUrl} avatarUrl={avatarUrl} />
      {/*Repositions section higher to accommodate the position of the logo that has also been moved up*/}
      <Box sx={{top: '-32px', position: 'relative'}}>
        <CompanyDescription
          name={name}
          description={safelyUseLanguageProfile(lang, description)}
          slogan={safelyUseLanguageProfile(lang, slogan)}
        />
      </Box>
      <CompanyOverview
        website={formatMissingText(websiteUrl)}
        companyType={formatMissingText(capitalizeFirstLetter(companyType))}
        workMode={formatMissingText(capitalizeFirstLetter(workMode))}
        averageAge={formatMissingText(averageEmployeeAge)}
        branch={formatMissingText(capitalizeFirstLetter(safelyUseLanguageProfile(lang, industry)))}
        mainLocation={locations[0].city}
        percentOfWomen={formatMissingText(percOfWomenInLeadership)}
        percentParents={formatMissingText(percOfEmployeesAreParents)}
        size={formatMissingText(capitalizeFirstLetter(employeeCountRange))}
        language={formatMissingText(primaryCompanyLanguage)}
      />
    </EmpionPaper>
  );
};
